/**
 * Contentful CDA identifiers used across the app.
 * - Tags: `metadata.tags.sys.id` (FAQ, locales, propertyImages, …)
 * - Content types: `sys.contentType.sys.id` / `content_type` query param
 */

export const CONTENTFUL_TAGS = {
  /** ADHA journey — locales, FAQs, etc. */
  ADHA: 'adha',
  /**
   * ADHA reservation status override copy (`reservationStatus.<normalized SF status>`).
   * Fetched separately on ADHA role so status messages can land after first paint.
   */
  ADHA_RESERVATION_STATUS: 'adhaReservationStatus',
  /** App-wide login config (`config` content type + `config` tag). */
  CONFIG: 'config',
  /** Guest catalogue — all guest `propertyImages` entries. */
  GUEST: 'guest',
} as const;

export type ContentfulTagId =
  (typeof CONTENTFUL_TAGS)[keyof typeof CONTENTFUL_TAGS];

/** Bloom Universal Delivery API content type IDs. */
export const BLOOM_UNIVERSAL_CONTENT_TYPES = {
  hub: 'bloomUniversalHub',
} as const;
